import React  from 'react';
import DeleteModal from "../../../../Modals/DeleteModal";
import CustomTable from "../../../../../components/table/CustomTable";
import {ButtonLargeTransparent} from "../../../../../components/buttons/ButtonLargeTransparent";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {TrashOutlineIcon} from "../../../../../components/buttons/IconButtons";
import DividerWithText from "../../../../../components/DividerWithText";
import OutputTableApp from "../Functionality/OutputTableApp";
import CreateOutputModal from "../../Outputs/Modal/CreateOutputModal";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const OutputTable = ({ defaultSioList, disabled }) => {
    const {
        t,
        id,
        thead,
        tbody,
        tableId,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        deleteShow,
        setDeleteShow,
        showCreateModal,
        setShowCreateModal,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelected
    } = OutputTableApp({ defaultSioList });

    return (
        <>
            <div className='row mt-4'>
                <DividerWithText title={t('outputs')} />
                {!disabled && (
                <div className='d-flex justify-content-end mb-2'>
                    <ButtonAction
                        id='btn_ot_delete_output'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteShow(true);
                        }}
                    />
                </div>
                )}
                <CustomTable
                    tableId={tableId}
                    checkbox={!disabled}
                    checkboxTitle={"de_/_select_all"}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectedList}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                    withoutHeight={true}
                />
                {!disabled && (
                <div className='my-2'>
                    <ButtonLargeTransparent
                        id="btn_ot_create_output"
                        click={() => {
                            setShowCreateModal(true);
                        }}
                        text={t("create_output")}
                    />
                </div>
                )}

            </div>

            {showCreateModal &&
                <CreateOutputModal
                    controllerId={id}
                    show={showCreateModal}
                    onHide={() =>  setShowCreateModal(false)}
                    setModified={setModified}
                />
            }

            <DeleteModal
                show={deleteShow}
                onHide={() => setDeleteShow(false)}
                onClickFn={() => deleteSelected()}
                data={selectedList}
                isReset={setSelectedList}
                isAllReset={setIsAllChecked}
                title_modal={t('delete_output')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('outputs')}
            />
        </>
    );
};

export default OutputTable;
